module.exports = __webpack_public_path__ + "img/img7.67bbf0e9.png";